import request from '@/plugin/axios';

//	是否为代报名培训人员信息查询接口
export function Trianset (params) {
  return request({
    url: request.adornUrl(`/pxLeave/couponCount/${params.trainId}/${params.mbId}`),
    method: 'get',
    params
  });
}
